import { DateRangePicker } from '@/components/inputs/DateRangePicker/DateRangePicker'

import { FilterType } from '../../base/FilterableTable/FilterableTable.types'
import { datesToALC, datesToLabel } from './utils'

type Props = {
  label: string
  onFilterSelect: (value: FilterType) => void
  format?: string
  error?: boolean
  width?: number | string
}

export const DateRangeFilter = ({ label, format, error, width, onFilterSelect }: Props) => {
  const handleFilterChange = ({
    startDate,
    endDate
  }: {
    startDate: Date | null
    endDate: Date | null
  }) => {
    onFilterSelect({
      value: datesToALC([startDate, endDate]),
      label: datesToLabel([startDate, endDate])
    })
  }

  return (
    <DateRangePicker
      clearAfterSelect
      label={label}
      format={format}
      error={error}
      width={width}
      onChange={handleFilterChange}
    />
  )
}
